"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.tagsEditor",
    path: "tags",
    component: "TagsEditor"
});
let TagsEditor = class TagsEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tagTypes;
    async $$load_tagTypes() {
        return this.$fn.fetch('list_tag_types');
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: '*' } })
            .then(data => _.flatten(_.values(data)))
            .then(p => _.map(p, pp => _.extend(pp, {
            id: `${pp.tag_type}:${pp.name}`
        })));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_8564662037462133_columns;
    async $$load_b_8564662037462133_columns() {
        return [{
                name: "tag_type",
                type: "select",
                header: this.$fn.pgettext("Tag", "Type"),
                width: "200px",
                required: true,
                options: this.tagTypes,
                valueField: "value",
                textField: "name",
            },
            {
                name: "name",
                header: this.$fn.pgettext("Tag", "Name"),
                width: "200px",
                required: true,
            },
        ];
    }
    dataMembers = ['tagTypes', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                tagTypes: null,
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_8564662037462133_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5562_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_script_5564_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('tag').upsert({ ...$event.data.row }));
    }
    async act_8564662037462133_script_5564_getActionArgs($event) {
        return {
            value: () => this.act_8564662037462133_script_5564_getActionArgs_value($event),
        };
    }
    async evh_8564662037462133_save(event, scope) {
        return await this.actions.evh_8564662037462133_save.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_script_5566_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('tag').delete({ ...$event.data.row }));
    }
    async act_8564662037462133_script_5566_getActionArgs($event) {
        return {
            value: () => this.act_8564662037462133_script_5566_getActionArgs_value($event),
        };
    }
    async evh_8564662037462133_delete(event, scope) {
        return await this.actions.evh_8564662037462133_delete.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5562 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5562_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5561 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5562,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5561],
        });
        const act_8564662037462133_script_5564 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8564662037462133_script_5564_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_save_5563 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_script_5564,
            event: "save",
            displayName: "script",
        });
        const evh_8564662037462133_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_save_5563],
        });
        const act_8564662037462133_script_5566 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8564662037462133_script_5566_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_delete_5565 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_script_5566,
            event: "delete",
            displayName: "script",
        });
        const evh_8564662037462133_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_delete_5565],
        });
        return {
            act_7315092382398562_closeModal_5562,
            evh_7315092382398562_close_5561,
            evh_7315092382398562_close,
            act_8564662037462133_script_5564,
            evh_8564662037462133_save_5563,
            evh_8564662037462133_save,
            act_8564662037462133_script_5566,
            evh_8564662037462133_delete_5565,
            evh_8564662037462133_delete,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], TagsEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TagsEditor.prototype, "onSize", null);
TagsEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], TagsEditor);
exports.default = TagsEditor;
vue_property_decorator_1.Vue.component("TagsEditor", TagsEditor);
